import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "auth" }
const _hoisted_2 = {
  key: 0,
  class: "auth-loader flex-center"
}
const _hoisted_3 = { class: "skyscraper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "skeleton-loader" }, null, -1 /* HOISTED */)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"clip_opt-icon\"><rect width=\"1780\" height=\"960\" style=\"fill:none;\"></rect></clipPath></defs><g style=\"clip-path:url(#clip_opt-icon);\"><path class=\"icon-path filled\" d=\"M1091,148c-162.47,0-295,132.65-295,295.28V904.63c0,30,25.35,55.37,55.31,55.37s55.32-25.38,55.32-55.37V674c50.7,40.38,114.08,64.6,184.37,64.6,162.47,0,295-132.65,295-295.27S1253.47,148,1091,148m0,479.82c-101.41,0-184.37-83-184.37-184.54s83-184.55,184.37-184.55,184.37,83,184.37,184.54-83,184.55-184.37,184.55\"></path><path class=\"icon-path filled\" d=\"M1724.66,627.29h-55.33a110.7,110.7,0,0,1-110.66-110.7V258.3h166c30,0,55.34-25.37,55.34-55.36s-25.36-55.35-55.34-55.35h-166V55.34c0-30-25.36-55.34-55.34-55.34S1448,25.36,1448,55.34V516.59C1448,638.84,1547.13,738,1669.33,738h55.33c30,0,55.34-25.37,55.34-55.35s-25.36-55.36-55.34-55.36\"></path><path class=\"icon-path filled\" d=\"M369,0C164.9,0,0,164.89,0,369S164.9,738,369,738,738,573.1,738,369,573.1,0,369,0m0,627.29C226.34,627.3,110.69,511.66,110.68,369S226.31,110.7,369,110.69,627.29,226.32,627.29,369v0c.24,142.41-115,258-257.43,258.29H369\"></path><path class=\"icon-path filled\" d=\"M393.47,356.5V175.3a31.18,31.18,0,1,0-62.35,0V382L475.73,529.58a31.18,31.18,0,0,0,44.54-43.65Z\"></path></g>", 2)
const _hoisted_8 = [
  _hoisted_6
]
const _hoisted_9 = {
  key: 0,
  class: "form login"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "header-1" }, "Send Verification", -1 /* HOISTED */)
const _hoisted_11 = { class: "input-container login" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  class: "link why-link",
  href: "https://www.google.com"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Why am I being asked for this?")
], -1 /* HOISTED */)
const _hoisted_13 = { class: "error-msg" }
const _hoisted_14 = { class: "message" }
const _hoisted_15 = { class: "btn-container login" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Dont have an account?")
const _hoisted_18 = {
  key: 1,
  class: "form signup"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", { class: "header-1" }, "Create Account", -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Looks like you don't have an Opt Account. Enter your details below", -1 /* HOISTED */)
const _hoisted_21 = { class: "input-container" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "error-msg" }
const _hoisted_24 = { class: "message" }
const _hoisted_25 = { class: "terms-container" }
const _hoisted_26 = { class: "checkbox-container" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "label-container" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "flex-label",
    for: "checkbox"
  }, [
    /*#__PURE__*/_createTextVNode("By signing up I agree to the "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.google.com" }, "terms of service and privacy policy")
  ])
], -1 /* HOISTED */)
const _hoisted_28 = { class: "btn-container" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 2,
  class: "form"
}
const _hoisted_31 = { class: "verify" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h1", { class: "header-1 form-header flex-center" }, "Verification Code", -1 /* HOISTED */)
const _hoisted_33 = { class: "description" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_35 = { class: "verification" }
const _hoisted_36 = {
  key: 0,
  class: "dev-hint"
}
const _hoisted_37 = { class: "error-msg" }
const _hoisted_38 = { class: "message" }
const _hoisted_39 = { class: "verification-btn-container" }
const _hoisted_40 = { class: "version" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routerLink = _resolveComponent("routerLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["VLoader"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["auth-container wide-card", { error: $setup.errorMsg }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("img", {
          class: _normalizeClass(["image", {login: $setup.stage == $setup.LoginStage.VERIFICATION, signup: $setup.stage == $setup.LoginStage.SIGNUP, verification: $setup.stage == $setup.LoginStage.CODE }]),
          src: $setup.imageSource
        }, null, 10 /* CLASS, PROPS */, _hoisted_5),
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["icon opt-icon", { 'white-opt': _ctx.$route.meta.redHeader}]),
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 1780 960"
        }, _hoisted_8, 2 /* CLASS */))
      ]),
      ($setup.stage == $setup.LoginStage.VERIFICATION)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              ($setup.verificationSelection == 'email')
                ? (_openBlock(), _createBlock($setup["VTextfield"], {
                    key: 0,
                    class: "input",
                    label: "Email",
                    modelValue: $setup.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event)),
                    onSubmit: $setup.sendVerificationCode
                  }, null, 8 /* PROPS */, ["modelValue"]))
                : (_openBlock(), _createBlock($setup["VPhoneInput"], {
                    key: 1,
                    class: "input",
                    label: "Phone Number",
                    modelValue: $setup.phone,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.phone) = $event)),
                    onSubmit: $setup.sendVerificationCode
                  }, null, 8 /* PROPS */, ["modelValue"]))
            ]),
            ($setup.verificationSelection == 'phone')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "change-method",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.verificationSelection = 'email'))
                }, "Verify with an email address instead"))
              : _createCommentVNode("v-if", true),
            ($setup.verificationSelection == 'email')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "change-method",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.verificationSelection = 'phone'))
                }, "Verify with an phone number instead"))
              : _createCommentVNode("v-if", true),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString($setup.errorMsg), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "primary sendVerificationCode create",
                disabled: $setup.email == null && $setup.phone == null,
                onClick: $setup.sendVerificationCode
              }, "Send Verification Code", 8 /* PROPS */, _hoisted_16),
              _createVNode(_component_routerLink, {
                class: "text-button link moveToLogin",
                to: {name: 'new-login'}
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.stage == $setup.LoginStage.SIGNUP)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode($setup["VTextfield"], {
                label: "First Name",
                modelValue: $setup.firstName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.firstName) = $event))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createVNode($setup["VTextfield"], {
                label: "Last Name",
                modelValue: $setup.lastName,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.lastName) = $event))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createVNode($setup["VTextfield"], {
                label: "Email",
                modelValue: $setup.email,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.email) = $event))
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createVNode($setup["VPhoneInput"], {
                modelValue: $setup.phone,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.phone) = $event)),
                label: "Phone Number"
              }, null, 8 /* PROPS */, ["modelValue"]),
              ($setup.env == 'development')
                ? (_openBlock(), _createElementBlock("label", _hoisted_22, "Real number or 555-555-0100 to 0199"))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString($setup.errorMsg), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode($setup["VCheckbox"], {
                  class: "checkbox",
                  modelValue: $setup.acceptedTerms,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.acceptedTerms) = $event))
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _hoisted_27
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                class: "primary create",
                disabled: !$setup.verificationSelection || !$setup.acceptedTerms,
                onClick: $setup.createAccount
              }, "Create Account", 8 /* PROPS */, _hoisted_29)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.stage == $setup.LoginStage.CODE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createTextVNode("Please check your " + _toDisplayString($setup.verificationSelection == 'email' ? 'email' : 'text messages') + " for the 5 digit code we sent you. If you did not receive it, ", 1 /* TEXT */),
                _createElementVNode("a", {
                  class: "resend-link",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.sendVerificationCode(true)))
                }, "tap to resend here"),
                _hoisted_34
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode($setup["VCodeInput"], {
                  class: "verificationCode",
                  length: 5,
                  modelValue: $setup.inputCode,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.inputCode) = $event))
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              ($setup.isDevEnvironment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Developer Hint: Your code is: " + _toDisplayString($setup.DEV_code), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, _toDisplayString($setup.errorMsg), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("button", {
                  class: "back-btn borderless",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.stage = $setup.LoginStage.VERIFICATION))
                }, "Back"),
                _createElementVNode("button", {
                  class: "submit-code-btn borderless",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.loginWithCode($setup.inputCode)))
                }, "Submit Code")
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_40, [
        _createVNode($setup["VersionLabel"])
      ])
    ], 2 /* CLASS */)
  ]))
}